export default __webpack_public_path__ + "static/media/qr-code-scan.b6a66932.svg";